<template>
  <bv-view />
</template>
